export default __webpack_public_path__ + "static/Auftragsabwicklung-9ea3740d3bcf55c0c4e7685a68d549ed.webp";